import { render } from "./DropMenu.vue?vue&type=template&id=04b3dbc3&scoped=true"
import script from "./DropMenu.vue?vue&type=script&lang=js"
export * from "./DropMenu.vue?vue&type=script&lang=js"

import "./DropMenu.vue?vue&type=style&index=0&id=04b3dbc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b3dbc3"]])

export default __exports__